import ContactVerificationPage from '@/presentation/pages/contact-verification/contact-verification-page'

export function makeContactVerificationPage() {
  return <ContactVerificationPage />
}
